import React, { useState } from 'react'
import { Grid, InputAdornment, MenuItem, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'
import FilterAltIcon from '@mui/icons-material/FilterAlt'

import LeadListFilterDrawer from './LeadListFilterDrawer'
import { EExpiredDateStatus } from '../../../../../../../types/lead'
import { Dayjs } from 'dayjs'
import ExportExcel from '../../../../../../../components/Export'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string | null
  searchBy?: string
  startDate?: string
  endDate?: string
  pipelineObjectId?: string
  activePipelineItemObjectId?: string
  assignToObjectId?: string
  expiredDateStatus?: EExpiredDateStatus
  assignTo?: string
  unfollowUpDate?: number
}

interface FilterProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  onDownload?: (date: Dayjs) => void
}

const LeadListFilter = ({
  onFilterChange,
  filter,
  onSearch,
  onDownload,
}: FilterProps) => {
  const { search, searchBy } = filter
  const [isOpenedFilterDrawer, setIsOpenedFilterDrawer] =
    useState<boolean>(false)

  return (
    <>
      <LeadListFilterDrawer
        isOpen={isOpenedFilterDrawer}
        onClose={() => setIsOpenedFilterDrawer(false)}
        onFilterChange={onFilterChange}
        filter={filter}
        onSearch={onSearch}
      />
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={2}>
          <TextField
            label={'ประเภทการค้นหา'}
            fullWidth
            id="searchBy"
            name="searchBy"
            variant="filled"
            value={searchBy || 'name'}
            onChange={(e) =>
              onFilterChange({ ...filter, searchBy: e.target.value?.trim() })
            }
            select
          >
            <MenuItem value="name">ชื่อ</MenuItem>
            <MenuItem value="phone">หมายเลขโทรศัพท์</MenuItem>
            <MenuItem value="email">อีเมล</MenuItem>
            <MenuItem value="tags">ป้ายกำกับ</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} lg={2}>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            label={'ค้นหา'}
            fullWidth
            id="search"
            name="search"
            variant="filled"
            value={search || ''}
            onChange={(e) =>
              onFilterChange({ ...filter, search: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <TextField
            name="unfollowUpDate"
            fullWidth
            label="รายการไม่ได้ติดตาม (เดือน)"
            defaultValue={filter.unfollowUpDate || 0}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                unfollowUpDate: Number(e.target.value),
              })
            }
            select
          >
            <MenuItem value={0}>ไม่ระบุ</MenuItem>
            <MenuItem value={30}>1 เดือน</MenuItem>
            <MenuItem value={60}>2 เดือน</MenuItem>
            <MenuItem value={90}>3 เดือน</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button
            color="inherit"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<FilterAltIcon />}
            onClick={() => {
              setIsOpenedFilterDrawer(true)
            }}
            sx={{ height: '100%' }}
          >
            ค้นหาโดยละเอียด
          </Button>
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button
            color="primary"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => onSearch(filter)}
            sx={{ height: '100%' }}
          >
            ค้นหา
          </Button>
        </Grid>
        <Grid item xs={12} lg={2}>
          <ExportExcel onDownload={onDownload} />
        </Grid>
      </Grid>
    </>
  )
}

export default LeadListFilter
